export enum EmailType {
  work = 'work',
  home = 'personal',
  mobile = 'mobile',
  other = 'other',
  homeowner = 'homeowner',
  spouse = 'spouse',
  coOwner = 'co-owner',
  businessContact = 'business contact',
}
